type DateLike = string | Date;

export interface Formats {
  date: DateTimeFormatOptions;
  dateUtc?: DateTimeFormatOptions;
  time: DateTimeFormatOptions;
  timeUtc?: DateTimeFormatOptions;
  datetime: DateTimeFormatOptions;
  datetimeUtc?: DateTimeFormatOptions;
}

/**
 * The Intl.DateTimeFormatOptions has more options than are needed and they are not strongly typed, so this interface provides
 * a strongly typed version.
 * If other options not listed below are needed, they can simply be added.
 */
export interface DateTimeFormatOptions {
  timeZone?: "UTC";
  year?: "numeric" | "2-digit";
  month?: "numeric" | "2-digit" | "long" | "short" | "narrow";
  day?: "numeric" | "2-digit";
  hour?: "numeric" | "2-digit";
  hour12?: boolean;
  minute?: "numeric" | "2-digit";
  second?: "numeric" | "2-digit";
  timeZoneName?: "long" | "short";
  era?: "long" | "short" | "narrow";
  weekday?: "long" | "short" | "narrow";
}

const formats: Formats = {
  date: {
    year: "numeric",
    month: "numeric",
    day: "numeric"
  },
  time: {
    hour: "numeric",
    minute: "2-digit",
    second: "2-digit"
  },
  datetime: {
    year: "numeric",
    month: "numeric",
    day: "numeric",
    hour: "numeric",
    minute: "2-digit",
    second: "2-digit"
  }
};

formats.dateUtc = Object.assign({ timeZone: "UTC" }, formats.date);
formats.timeUtc = Object.assign({ timeZone: "UTC" }, formats.time);
formats.datetimeUtc = Object.assign({ timeZone: "UTC" }, formats.datetime);

export function formatDate(value?: DateLike, format?: keyof Formats) {
  if (value) {
    // If format is undefined or the format is invalid, default to the datetime format
    const options = formats[format || "datetime"] || formats["datetime"];

    return new Intl.DateTimeFormat("default", options).format(new Date(value));
  }
}
